export default __webpack_public_path__ + "static/media/pg-35.1c45d10f.jpg";